"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_TYPES = void 0;
exports.trackGenericActionEvent = trackGenericActionEvent;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _events = require("../../analytics/events");
var _utils = require("./utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var EVENT_TYPES = exports.EVENT_TYPES = {
  ACTION_EXTENSION_CLICKED: {
    name: 'Action extension clicked',
    required: [].concat((0, _toConsumableArray2.default)(_events.basicAssetProperties), ['section', 'actionId'])
  },
  API_VERSION_MADE_PUBLIC: {
    name: 'API version made public',
    required: _events.basicVersionGroupProperties
  },
  API_VERSION_MADE_PRIVATE: {
    name: 'API version made private',
    required: _events.basicVersionGroupProperties
  },
  ASSET_DOWNLOADED: {
    name: 'Downloaded asset',
    required: [].concat((0, _toConsumableArray2.default)(_events.basicAssetProperties), ['classifier'])
  }
};
function trackGenericActionEvent(_ref) {
  var asset = _ref.asset,
    actionId = _ref.actionId,
    section = _ref.section,
    trackEvent = _ref.trackEvent;
  var eventProperties = _objectSpread(_objectSpread({}, (0, _utils.assetProperties)({
    asset: asset
  })), {}, {
    section: section,
    actionId: actionId
  });
  trackEvent(EVENT_TYPES.ACTION_EXTENSION_CLICKED, eventProperties);
}
//# sourceMappingURL=events.js.map